import { Task, Priority, Effort } from '../types'
import { isDateToday, todayISO } from './dateUtils'

export const isTaskToday = (task: Task): boolean =>
  task.isToday || (!!task.dueDate && isDateToday(task.dueDate))

export const priorityLabel: Record<Priority, string> = {
  low: 'Baixa',
  medium: 'Média',
  high: 'Alta',
  urgent: 'Urgente',
}

export const priorityColor: Record<Priority, string> = {
  low: 'bg-slate-100 text-slate-600',
  medium: 'bg-blue-100 text-blue-700',
  high: 'bg-orange-100 text-orange-700',
  urgent: 'bg-red-100 text-red-700',
}

export const priorityDot: Record<Priority, string> = {
  low: 'bg-slate-400',
  medium: 'bg-blue-500',
  high: 'bg-orange-500',
  urgent: 'bg-red-500',
}

export const effortLabel: Record<Effort, string> = {
  1: 'Muito baixo',
  2: 'Baixo',
  3: 'Médio',
  4: 'Alto',
  5: 'Muito alto',
}

export const statusLabel = {
  todo: 'A Fazer',
  'in-progress': 'Em Andamento',
  done: 'Concluído',
}

export const statusColor = {
  todo: 'bg-slate-100 text-slate-700',
  'in-progress': 'bg-blue-100 text-blue-700',
  done: 'bg-green-100 text-green-700',
}

export const priorityNumeric: Record<Priority, number> = {
  low: 1,
  medium: 2,
  high: 3,
  urgent: 4,
}

export const getCompletionStats = (tasks: Task[]) => {
  const total = tasks.length
  const done = tasks.filter((t) => t.status === 'done').length
  const inProgress = tasks.filter((t) => t.status === 'in-progress').length
  const todo = tasks.filter((t) => t.status === 'todo').length
  const pct = total === 0 ? 0 : Math.round((done / total) * 100)
  return { total, done, inProgress, todo, pct }
}

export const getTodayTasks = (tasks: Task[]) =>
  tasks.filter(isTaskToday)

export const newTaskDefaults = () => ({
  title: '',
  description: '',
  status: 'todo' as const,
  priority: 'medium' as const,
  effort: 3 as Effort,
  dueDate: todayISO(),
  startDate: todayISO(),
  startTime: '',
  endTime: '',
  completedAt: undefined,
  isToday: false,
  subtasks: [],
  comments: [],
  links: [],
  projectId: '',
  tags: [],
})
